<template>
  <q-markup-table
    separator="cell"
    flat
    bordered
    dense
  >
    <thead>
      <tr>
        <th>
          Recognized Revenue
          <q-chip
            v-if="effectiveDate"
            square
            size="sm"
            dense
          >
            {{ $d(effectiveDate, 'longDate') }}
            <q-tooltip>
              Effective Date
            </q-tooltip>
          </q-chip>
        </th>
        <th>Time</th>
        <th>Amount</th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="effectiveDatum in effectiveData"
        :key="effectiveDatum.label"
      >
        <td class="sub-label">
          <div
            class="ellipsis"
            style="max-width: 255px;"
          >
            {{ effectiveDatum.label }}
          </div>
        </td>
        <td class="sub-label">
          <formatted-date
            :value="effectiveDatum.time"
            format="icon"
          />
        </td>
        <td class="cell-value">
          <formatted-number :value="effectiveDatum.value" />
          <q-tooltip
            v-if="effectiveDatum.tooltip"
            :delay="550"
          >
            {{ effectiveDatum.tooltip }}
          </q-tooltip>
        </td>
      </tr>
      <tr
        class="grand-total-row"
      >
        <td>
          Total
        </td>
        <td />
        <td class="cell-value">
          <formatted-number
            :value="$_(effectiveData).map('value').sum()"
          />
        </td>
      </tr>
    </tbody>
  </q-markup-table>
</template>

<script>

import FormattedDate from 'src/modules/admin/components/FormattedDate.vue'
import FormattedNumber from 'src/modules/admin/components/FormattedNumber'

export default {
  name: 'OrderItemRevenueTable',
  components: { FormattedNumber, FormattedDate },
  props: {
    orderItem: {
      type: Object,
      required: true
    },
    effectiveDate: {
      type: Date,
      required: true
    }
  },
  computed: {
    effectiveData () {
      const effectiveData = []
      const orderItem = this.orderItem

      if (orderItem.purchaseEffectiveDate.getTime() === this.effectiveDate.getTime()) {
        effectiveData.push({
          label: 'Net Due From Customer',
          time: orderItem.effectiveAt,
          value: orderItem.netAmount
        })
        if (orderItem.voucherType || orderItem.voucher) {
          effectiveData.push({
            label: `Recognized Voucher Revenue — ${orderItem.displayVoucherName}`,
            time: orderItem.effectiveAt,
            value: orderItem.recognizedVoucherRevenue
          })
        } else {
          effectiveData.push({
            label: 'No Voucher Used',
            time: null,
            value: orderItem.recognizedVoucherRevenue
          })
        }
      }

      if (orderItem.voidEffectiveDate && orderItem.voidEffectiveDate.getTime() === this.effectiveDate.getTime()) {
        effectiveData.push({
          label: 'Void of Net Due From Customer',
          time: orderItem.voidedAt,
          value: -orderItem.netAmount
        })
        if (orderItem.voucherType || orderItem.voucher) {
          effectiveData.push({
            label: `Void of Recognized Voucher Revenue — ${orderItem.displayVoucherName}`,
            time: orderItem.voidedAt,
            value: -orderItem.recognizedVoucherRevenue
          })
        } else {
          effectiveData.push({
            label: 'No Voucher Used',
            time: null,
            value: -orderItem.recognizedVoucherRevenue
          })
        }
      }

      return effectiveData
    }
  }
}

</script>

<style lang="scss">
th,
.bold-label {
  font-weight: bold;
}

.sub-label {
  padding-left: 1em;
}

.cell-value {
  text-align: right;
}

.total-row td {
  border-top: solid 1px #444;
}

.grand-total-row td {
  font-weight: bold;
  border-top: double 3px #444;
}
</style>
